import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
  }

  html,
  body,
  #root {
    width: 100%;
    max-width: 100%;
  }

  #root {
    overflow-x: clip;
  }

  :root {
    /* tinge selects nativos, checkboxes, radios e date inputs com a cor da marca */
    accent-color: ${({ theme }) => theme.colors.orange.primary};
  }

  body {
    background-color: ${({ theme }) => theme.colors.background.white};
    color: ${({ theme }) => theme.colors.neutralDark[40]};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  button {
    cursor: pointer;
  }

  /* Works on Firefox */
  * {
    scrollbar-width: 0.5vw;
    scrollbar-color: #726E6B40;
  }

  /* Works on Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 10px;
  }

  *::-webkit-scrollbar-track:overflow-x {
    background: transparent;
  }

  *::-webkit-scrollbar:horizontal {
    display: none;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #CCCBCC;
    border: none;
    border-radius: 8px;
  }
`;
